import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  Box,
  Avatar,
  Typography,
  TextField,
  CircularProgress,
} from '@mui/material';
import { AddAPhoto as PhotoCamera } from '@mui/icons-material';

const ProfileEditorAboutYourBoat = ({
  boatPicturePreview,
  isLoadingPhoto,
  handleBoatPictureChange,
  aboutBoat,
  setAboutBoat,
  boatName,
  setBoatName,
}) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);

  const handleAvatarClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    handleBoatPictureChange(event);
    // Reset the file input value so the same file can be selected again if needed
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            ref={fileInputRef}
            id="boat-picture-input"
            type="file"
            onChange={handleFileChange}
          />
          <Avatar variant="rounded"
            src={boatPicturePreview}
            onClick={handleAvatarClick}
            sx={{
              width: 200,
              height: 200,
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            {isLoadingPhoto ? (
              <CircularProgress />
            ) : (
              !boatPicturePreview && <PhotoCamera fontSize="large" />
            )}
          </Avatar>
          <Typography variant="caption" sx={{ mt: 1 }}>
            {t(`profile.aboutYourBoat.boatPicture.${boatPicturePreview ? 'change' : 'select'}`)}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm={8}>
         <TextField
          fullWidth
          label={t('profile.aboutYourBoat.boatName.label')}
          value={boatName}
          onChange={(e) => setBoatName(e.target.value)}
          margin="normal"
          placeholder={t('profile.aboutYourBoat.boatName.placeholder')}
          slotProps={{ input: { maxLength: 100 } }}
        />
        <TextField
          fullWidth
          label={t('profile.aboutYourBoat.aboutBoat.label')}
          value={aboutBoat}
          onChange={(e) => setAboutBoat(e.target.value)}
          margin="normal"
          multiline
          rows={4}
          placeholder={t('profile.aboutYourBoat.aboutBoat.placeholder')}
          slotProps={{ input: { maxLength: 1000 } }}
        />
      </Grid>
    </Grid>
  );
};

export default ProfileEditorAboutYourBoat;
